export const LINKED_EMPLOYEE_SUBMISSION_LABEL =
    'Require all linked employees to complete a form for each linked person';

export const LINKED_EMPLOYEE_SUBMISSION_TOOLTIP =
    'When ticked, each linked employee receives their own form to complete for each linked person. When unticked, one shared form is assigned, and any linked employee can claim or submit it.';

export const LINKED_EMPLOYEE_SUBMISSION_QUESTION =
    'Do you require every linked employee to complete this form for each linked person?';

export const LINKED_EMPLOYEE_SUBMISSION_OPTIONS = [
    {
        id: 'false',
        description: 'No, any linked employee can complete it'
    },
    {
        id: 'true',
        description: 'Yes, every linked employee must complete it'
    }
];
